<svg
   xmlns="http://www.w3.org/2000/svg"
   [attr.class]="class"
   [attr.width]="width + 'px'"
   [attr.height]="height + 'px'"
   [attr.fill]="fill">
   <use [attr.xlink:href]="iconUrl"></use>
</svg>
